import { render, staticRenderFns } from "./consult_done.vue?vue&type=template&id=94f7593c&"
import script from "./consult_done.vue?vue&type=script&lang=js&"
export * from "./consult_done.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports